import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  summaryRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: 14,
  },
  orderResumeItemDetailText: {
    flex: 1,
    textAlign: 'right',
  },
  oldPriceText: {
    textDecorationLine: 'line-through',
    textDecorationStyle: 'solid',
    fontSize: 11,
  },
  discountedPriceText: {
    fontSize: 16,
  },
});
